/*!

=========================================================
* Now UI Dashboard Pro Angular - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-pro-angular
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { registerLicense } from '@syncfusion/ej2-base';
if (environment.production) {
  enableProdMode();
}

registerLicense('Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXtcdHRRQmRcVUR3WkJWYU4=');

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
